const constants = require('@/util/constants')
import i18n from '@/i18n'
i18n.locale = localStorage.i18n

export default {
  /**
   * passport
   */
  passport: {
    token: {
      access_token: '',
      expires_in: 0,
      jti: '',
      refresh_token: '',
      scope: '',
      token_type: ''
    }
  },
  /**
   * 当前登录用户
   * 权限：authorities
   */
  user: {
    // 用户个人信息
    info: {
      uid: '',
      username: '',
      nickname: '',
      realName: '',
      avatar: constants.DEFAULT_WEB_AVATAR_URL,
      email: '',
      mobile: '',
      subDomain: '',
      imStatus: '',
      acceptStatus: '',
      webrtcStatus: 'online',
      autoReplyContent: '',
      autoReplyImageUrl: '',
      connectionStatus: '',
      validateUntilDate: '',
      balance: 0,
      roles: [],
      description: ''
    },
    // 自动回复历史列表
    autoReplyList: [],
    is_admin: false,
    // 会话类型：thread/contact/group
    current_chat_type: 'thread',
    // 同一公司同事
    contacts: [],
    current_contact: {
      id: 0,
      username: '',
      nickname: '',
      realName: '',
      avatar: '',
      email: '',
      mobile: ''
    },
    // 当前访客用户信息
    current_visitor_info: {
      uid: '',
      username: '',
      nickname: '',
      avatar: '',
      email: '',
      mobile: '',
      description: ''
    },
    // 当前访客crm信息
    current_crm: {
      id: 0,
      cid: '',
      name: '',
      email: '',
      mobile: '',
      age: 0,
      job: '',
      company: '',
      description: '',
      tid: '',
      tags: [],
      uid: ''
    },
    crms: [],
    customers: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    // 所有默认所在 和 加入的群
    groups: [],
    current_group: {
      id: 0
    },
    // 根据权限控制div是否显示/隐藏
    show_authority: {
      home: false,
      statistic: false,
      chat: true,
      thread: true,
      visitor: true,
      history: true,
      monitor: false,
      quality: false,
      robot: false,
      support: false,
      setting: true,
      feedback: false,
      workorder: false,
      callcenter: false,
      crm: false,
      wenjuan: false,
      internal: false,
      //
      admin: false,
      debug: false,
      free: false,
      try: false,
      vip: false
    },
    // 排队中的访客
    // queues: [],
    queues: {
      content: []
    },
    // 已经订阅的topics
    subscribed_topics: [],
    // 黑名单
    blocks: {
      content: [],
      empty: false,
      first: true,
      last: false,
      number: 0,
      numberOfElements: 0,
      size: 0,
      totalElements: 0,
      totalPages: 0
    },
    current_block: {
      bid: '',
      type: '',
      note: '',
      blockedUser: {
        uid: '',
        nickname: '',
        avatar: constants.DEFAULT_WEB_AVATAR_URL,
        username: ''
      }
    },
    // 所有当前会话
    threads: [],
    // 置顶会话
    top_threads: [],
    // 免打扰会话-topic
    nodisturb_thread_topics: [],
    // 未读会话-topic
    unread_thread_topics: [],
    // 星标会话-topic，合并所有star
    star_threads: [],
    // 废弃
    star1_threads: [],
    star2_threads: [],
    star3_threads: [],
    star4_threads: [],
    //
    note_map: new Map(),
    // 客服
    agent_threads: [],
    // 同事会话
    contact_threads: [],
    // 群组会话
    group_threads: [],
    // 渠道会话
    channel_threads: [],
    // 工单会话
    ticket_threads: [],
    // 意见反馈会话
    feedback_threads: [],
    // 当前会话
    current_thread: {
      id: 0,
      tid: '',
      topic: '',
      type: '',
      content: '',
      nickname: '',
      avatar: constants.DEFAULT_WEB_AVATAR_URL,
      timestamp: '',
      unreadCount: 0,
      client: '',
      description: ''
      // queue: Object,
      // visitor: {
      //   uid: '',
      //   username: '',
      //   nickname: '',
      //   avatar: constants.DEFAULT_WEB_AVATAR_URL
      // },
    },
    current_thread_more: {
      // 加载更多聊天消息相关
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    // 当前会话对应网址
    current_thread_url: {
      url: '',
      preUrl: '',
      title: ''
    },
    // 当前排队
    current_queue: {
      qid: '',
      visitor: {
        nickname: '',
        avatar: '',
        description: ''
      }
    },
    // 草稿，输入框
    drafts: [
      {
        key: '',
        value: ''
      }
    ],
    // 自定义表情
    selfEmojis: {
      content: []
    },
    // 图片管理器
    selfImages: {
      content: []
    },
    // 文件管理器
    selfFiles: {
      content: []
    },
    // 网页浏览中的访客
    browses: [],
    current_browse: {
      bid: '',
      visitor: {
        nickname: '',
        avatar: '',
        description: ''
      }
    },
    // 网页浏览访客
    notice_browses: [],
    current_notice_browse: {
      user: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      notice: {
        topic: '',
        type: '',
        content: {
          referer: '',
          url: '',
          title: ''
        }
      }
    },
    // 通知
    notices: [],
    current_notice: {
      nid: '',
      title: '',
      content: '',
      type: '',
      urgent: false,
      attachments: [],
      user: {
        realName: ''
      },
      createdAt: ''
    },
    // 待办任务
    todos: [],
    current_todo: {
      tid: '',
      title: '',
      content: '',
      type: '',
      attachments: [],
      createdAt: ''
    },
    // 当前在线用户
    current_online_user: {
      uid: '',
      nickname: '',
      avatar: ''
    },
    // 在线访客
    onlineUsers: {
      content: [],
      totalPages: 0,
      totalElements: 0
    },
    // 当前工单
    tickets: [],
    formereply_tickets: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    tobereplied_tickets: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    done_tickets: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    ignored_tickets: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    closed_tickets: {
      content: [],
      page: 0, // 当前页面
      first: true, //
      last: true, // 是否还有更多聊天记录
      totalElements: 0
    },
    current_ticket: {
      tid: '',
      title: '',
      content: '',
      thread: {
        id: 0,
        tid: '',
        topic: '',
        type: '',
        content: '',
        nickname: '',
      },
      visitorThread: {
        id: 0,
        tid: '',
        topic: '',
        type: '',
        content: '',
        nickname: '',
      },
      user: { // 创建人
        uid: '',
        nickname: '',
        avatar: ''
      },
      visitor: { // 访客
        uid: '',
        nickname: '',
        avatar: ''
      }
    },
    // 监控
    monitor_threads: [],
    // 插入会话的tid
    monitoring_thread_tids: [],
    // 当前监控
    current_monitor_thread: {
      id: 0,
      tid: '',
      topic: '',
      type: '',
      content: '',
      nickname: '',
      avatar: constants.DEFAULT_WEB_AVATAR_URL,
      timestamp: '',
      unreadCount: 0,
      // 加载更多聊天消息相关
      page: 0, // 当前页面
      first: true, //
      last: false, // 是否还有更多聊天记录
      totalElements: 0
    },
    // 所有小结
    summaries: {
      content: []
    },
    // 意见反馈
    feedbacks: {
      content: []
    },
    // 在线状态
    statuses: {
      content: []
    },
    // 所属工作组
    workGroups: [],
    // 输入框上方菜单按钮
    menus: [],
    // 所有消息
    messagesArchive: [],
    messages: [],
    protobufMessages: [],
    // 商品消息
    commodityMessages: [],
    // load more message，加载更多聊天记录
    mores: [{
      uid: '',
      page: 0,
      first: true,
      last: true,
      totalElements: 1
    }],
    // 当前登录管理员/客服账号设置信息
    settings: {
      sidebarColor: '#3f3f3f',
      notification: false,
      connection_status: 'connecting' // 长连接状态, 左下角连接标志
      // accept_status: 'online' // 用户接待状态
    },
    // 设备指纹信息
    fingerPrints: [],
    // 用户标签
    userTags: [],
    // 会话标签
    threadTags: []
  },
  // 右侧当前tab
  right_active_tab: 'cuw',
  // 网络连接状态
  network_connection_status: 'connected',
  // 是否正在拉取未读消息
  is_pulling_unread_message: false,
  // 是否显示底部统计数据
  show_bottom_statistics: true,
  // 会话列表显示超时
  show_out_of_time: false,
  // 是否显示输入时联想
  show_input_tip: true,
  // 是否检测是否绑定公众号
  query_mpqrcode_url: true,
  // 当前是否视频客服进行中
  is_webrtc_started: false,
  // 用户是否绑定微信公众号
  is_wechat_mp_binded: false,
  // 用户是否启用微信公众号推送
  is_wechat_mp_push_enabled: true,
  // 统计数据
  statistic: {
    online_agent_count: 0,
    current_thread_count: 0,
    current_queue_count: 0,
    today_total_thread_count: 0,
    today_total_queue_count: 0,
    today_leave_queue_count: 0,
    statistic_list: [],
    statistic_detail_list: [],
    threads: [],
    rates: []
  },
  // 当前客服实时统计数据
  statistics_agent_today: {
    threadCount: 0, // 接待人次
    lt30sRate: 0.0, // 30秒应答率
    satisfyRate: 0.0, // 评价满意率
    averageResponseLength: 0.0, // 平均人工响应时长
    responseLt3mRate: 0.0, // 3分钟人工回复率
    agentMessageCount: 0, // 发送消息数
    agentWordCount: 0, // 发送消息字数
    visitorMessageCount: 0, // 接收消息数
    visitorWordCount: 0, // 接收消息字数
  },
  statistics_agent_today_uids: [],
  /**
   * 管理员
   */
  // 角色
  roles: [],
  // 当前会话
  // threads: [],
  // 监控-机器人会话-进行中
  robot_threads_ongoing: {
    content: []
  },
  // 监控-机器人会话-以关闭
  robot_threads_closed: {
    content: []
  },
  // 客服端分页获取某一访客的历史会话
  histories: [],
  // 客服端分页加载-客服自己的历史会话：客服会话
  history_records: {
    content: [],
    empty: false,
    first: true,
    last: true,
    number: 0,
    numberOfElements: 20,
    size: 20,
    totalElements: 485,
    totalPages: 25
  },
  // 满意度评价
  rates: [],
  // 历史消息
  messages: [],
  // 留言
  leaveMessages: [],
  // 历史在线状态
  statuses: [],
  // 历史排队
  queues: [],
  // queues: {
  //   content: []
  // },
  // 历史浏览
  browses: [],
  // 会话监控
  monitors: [],
  // 质量检查
  qualities: [],
  // 管理员账号下的所有客服
  agents: {
    content: []
  },
  online_agents: {
    content: []
  },
  // 访客
  visitors_uniapp: {
    content: []
  },
  visitors_flutter: {
    content: []
  },
  visitors_android: {
    content: []
  },
  visitors_ios: {
    content: []
  },
  visitors_wechat: {
    content: []
  },
  // 管理员账号下的所有工作组
  // workGroups: {
  //   content: []
  // },
  // 省市
  regions: {
    provinces: [],
    cities: []
  },
  // 分公司
  companies: {
    content: []
  },
  // 分类: 快捷回复、智能问答、帮助中心
  categories: [],
  // 快捷回复
  cuws: [{
    id: 0,
    name: i18n.t('mine'),
    cuwChildren: []
  }, {
    id: -1,
    name: i18n.t('company'),
    cuwChildren: []
  }, {
    id: -2,
    name: i18n.t('default'),
    cuwChildren: []
  }],
  current_company_cuw_category_id: 0,
  // 智能问答
  robot: {
    // 知识库问答
    answers: [],
    // 知识库相似词
    synonyms: []
  },
  // 帮助中心
  support: {
    //
    articles: [],
    //
    comments: []
  },
  // 用于‘历史记录’页面过滤filter
  filter: {
    // 获取全部工作组
    workGroups: [],
    // 管理员获取全部成员/客服组长获取同组全部组员/客服账号返回自己
    workGroupMembers: []
  },
  // 问卷
  questionnaire: [],
  // 敏感词
  taboos: [],
  // 网站
  webs: [],
  // APP
  apps: [],
  // 公众号
  mps: [],
  // 小程序
  minis: [],
  // 当前显示主页面
  current_main_view: '',
  // load more message，加载更多聊天记录
  more_template: {
    username: 0, // thread会话tid
    page: 0, // 起步点
    last: false // 是否还有更多聊天记录
  },
  draft_templage: {
    thread_id: 0,
    content: ''
  },
  // 快捷回复模板, 没有实际用途，仅用做模板
  cuw_template: {
    id: 0,
    type: '', // workgroup/agent/standard
    title: '', // 此字段暂时没用
    content: '',
    children: []
  },
  // 没有实际用途，仅用做模板
  message_templage: {
    // 发送/接收消息-公共字段
    id: 0,
    user: {
      username: '',
      nickname: '',
      avatar: ''
    },
    type: '',
    role: '',
    // 注意：一条特定消息并不会包含所有字段，如：文本消息只会包含content字段
    // 文本消息
    content: '', // 文本消息
    // 图片消息
    pic_url: '', // 微信pic_url，web版容易引起跨域访问问题，所以要使用pic_url
    image_url: '', // 存储在自己服务器之后的url
    // 语音消息
    media_id: '', // 图片+语音+视频+短视频 公用字段
    format: '', // 语音格式amr等
    voice_url: '', // 语音url
    length: 0, // 语音长度
    is_played: false, // 是否已经播放过
    // 视频消息 & 短视频消息
    thumb_media_id: '',
    video_or_short_url: '', // 视频和短视频 url
    video_or_short_thumb_url: '', // 视频和短视频 thumb url
    // 地理位置消息
    location_x: '',
    location_y: '',
    scale: '',
    label: '',
    // 链接消息
    title: '',
    description: '',
    url: '',
    //
    client: '', // 消息来源web
    thread: Object, // thread id
    timestamp: '', // 时间戳
    // 发送出的消息-专有字段
    local_id: '', // 仅用于本地区分消息
    status: '' // 消息发送状态
  },
  //
  emotionWxTextMap: {
    '/::)': '[微笑]',
    '/::~': '[撇嘴]',
    '/::B': '[色]',
    '/::|': '[发呆]',
    '/:8-)': '[得意]',
    '/::<': '[流泪]',
    '/::$': '[害羞]',
    '/::X': '[闭嘴]',
    '/::Z': '[睡]',
    '/::\'(': '[大哭]',

    '/::-|': '[尴尬]',
    '/::@': '[发怒]',
    '/::P': '[调皮]',
    '/::D': '[呲牙]',
    '/::O': '[惊讶]',
    '/::(': '[难过]',
    '/::+': '[酷]',
    '/:-b': '[冷汗]',
    '/::Q': '[抓狂]',
    '/::T': '[吐]',

    '/:,@P': '[偷笑]',
    '/:,@-D': '[愉快]',
    '/::d': '[白眼]',
    '/:,@o': '[傲慢]',
    '/::g': '[饥饿]',
    '/:|-)': '[困]',
    '/::!': '[惊恐]',
    '/::L': '[流汗]',
    '/::>': '[憨笑]',
    '/::,@': '[悠闲]',

    '/:,@f': '[奋斗]',
    '/::-S': '[咒骂]',
    '/:?': '[疑问]',
    '/:,@x': '[嘘]',
    '/:,@@': '[晕]',
    '/::8': '[疯了]',
    '/:,@!': '[衰]',
    '/:!!!': '[骷髅]',
    '/:xx': '[敲打]',
    '/:bye': '[再见]',

    '/:wipe': '[擦汗]',
    '/:dig': '[抠鼻]',
    '/:handclap': '[鼓掌]',
    '/:&-(': '[糗大了]',
    '/:B-)': '[坏笑]',
    '/:<@': '[左哼哼]',
    '/:@>': '[右哼哼]',
    '/::-O': '[哈欠]',
    '/:>-|': '[鄙视]',
    '/:P-(': '[委屈]',

    '/::’|': '[快哭]',
    '/:X-)': '[阴险]',
    '/::*': '[亲亲]',
    '/:@x': '[吓]',
    '/:8*': '[可怜]',
    '/:pd': '[菜刀]',
    '/:<W>': '[西瓜]',
    '/:beer': '[啤酒]',
    '/:basketb': '[篮球]',
    '/:oo': '[乒乓]',

    '/:coffee': '[咖啡]',
    '/:eat': '[饭]',
    '/:pig': '[猪头]',
    '/:rose': '[玫瑰]',
    '/:fade': '[凋谢]',
    '/:showlove': '[嘴唇]',
    '/:heart': '[爱心]',
    '/:break': '[心碎]',
    '/:cake': '[蛋糕]',
    '/:li': '[闪电]',

    '/:bome': '[炸弹]',
    '/:kn': '[刀]',
    '/:footb': '[足球]',
    '/:ladybug': '[瓢虫]',
    '/:shit': '[便便]',
    '/:moon': '[月亮]',
    '/:sun': '[太阳]',
    '/:gift': '[礼物]',
    '/:hug': '[拥抱]',
    '/:strong': '[强]',

    '/:weak': '[弱]',
    '/:share': '[握手]',
    '/:v': '[胜利]',
    '/:@)': '[抱拳]',
    '/:jj': '[勾引]',
    '/:@@': '[拳头]',
    '/:bad': '[差劲]',
    '/:lvu': '[爱你]',
    '/:no': '[No]',
    '/:ok': '[OK]',

    '/:love': '[爱情]',
    '/:<L>': '[飞吻]',
    '/:jump': '[跳跳]',
    '/:shake': '[发抖]',
    '/:<O>': '[怄火]',
    '/:circle': '[转圈]',
    '/:kotow': '[磕头]',
    '/:turn': '[回头]',
    '/:skip': '[跳绳]',
    '/:oY': '[投降]',

    '/:#-0': '[激动]',
    '/:hiphot': '[乱舞]',
    '/:kiss': '[献吻]',
    '/:<&': '[左太极]',
    '/:&>': '[右太极]'
  },
  emotionWxMap: {
    '/::)': '100.gif',
    '/::~': '101.gif',
    '/::B': '102.gif',
    '/::|': '103.gif',
    '/:8-)': '104.gif',
    '/::<': '105.gif',
    '/::$': '106.gif',
    '/::X': '107.gif',
    '/::Z': '108.gif',
    '/::\'(': '109.gif', // 正则表达式识别失败

    '/::-|': '110.gif',
    '/::@': '111.gif',
    '/::P': '112.gif',
    '/::D': '113.gif',
    '/::O': '114.gif',
    '/::(': '115.gif',
    '/::+': '116.gif',
    '/:-b': '117.gif',
    '/::Q': '118.gif',
    '/::T': '119.gif',

    '/:,@P': '120.gif',
    '/:,@-D': '121.gif',
    '/::d': '122.gif',
    '/:,@o': '123.gif',
    '/::g': '124.gif',
    '/:|-)': '125.gif',
    '/::!': '126.gif',
    '/::L': '127.gif',
    '/::>': '128.gif',
    '/::,@': '129.gif',

    '/:,@f': '130.gif',
    '/::-S': '131.gif',
    '/:?': '132.gif',
    '/:,@x': '133.gif',
    '/:,@@': '134.gif',
    '/::8': '135.gif',
    '/:,@!': '136.gif',
    '/:!!!': '137.gif',
    '/:xx': '138.gif',
    '/:bye': '139.gif',

    '/:wipe': '140.gif',
    '/:dig': '141.gif',
    '/:handclap': '142.gif',
    '/:&-(': '143.gif',
    '/:B-)': '144.gif',
    '/:<@': '145.gif',
    '/:@>': '146.gif',
    '/::-O': '147.gif',
    '/:>-|': '148.gif',
    '/:P-(': '149.gif',

    '/::’|': '150.gif',
    '/:X-)': '151.gif',
    '/::*': '152.gif',
    '/:@x': '153.gif',
    '/:8*': '154.gif',
    '/:pd': '155.gif',
    '/:<W>': '156.gif',
    '/:beer': '157.gif',
    '/:basketb': '158.gif',
    '/:oo': '159.gif',

    '/:coffee': '160.gif',
    '/:eat': '161.gif',
    '/:pig': '162.gif',
    '/:rose': '163.gif',
    '/:fade': '164.gif',
    '/:showlove': '165.gif',
    '/:heart': '166.gif',
    '/:break': '167.gif',
    '/:cake': '168.gif',
    '/:li': '169.gif',

    '/:bome': '170.gif',
    '/:kn': '171.gif',
    '/:footb': '172.gif',
    '/:ladybug': '173.gif',
    '/:shit': '174.gif',
    '/:moon': '175.gif',
    '/:sun': '176.gif',
    '/:gift': '177.gif',
    '/:hug': '178.gif',
    '/:strong': '179.gif',

    '/:weak': '180.gif',
    '/:share': '181.gif',
    '/:v': '182.gif',
    '/:@)': '183.gif',
    '/:jj': '184.gif',
    '/:@@': '185.gif',
    '/:bad': '186.gif',
    '/:lvu': '187.gif',
    '/:no': '188.gif',
    '/:ok': '189.gif',

    '/:love': '190.gif',
    '/:<L>': '191.gif',
    '/:jump': '192.gif',
    '/:shake': '193.gif',
    '/:<O>': '194.gif',
    '/:circle': '195.gif',
    '/:kotow': '196.gif',
    '/:turn': '197.gif',
    '/:skip': '198.gif',
    '/:oY': '199.gif',

    '/:#-0': '200.gif',
    '/:hiphot': '201.gif',
    '/:kiss': '202.gif',
    '/:<&': '203.gif',
    '/:&>': '204.gif'
  },
  //
  emotionMap: {
    '[微笑]': '100.gif',
    '[撇嘴]': '101.gif',
    '[色]': '102.gif',
    '[发呆]': '103.gif',
    '[得意]': '104.gif',
    '[流泪]': '105.gif',
    '[害羞]': '106.gif',
    '[闭嘴]': '107.gif',
    '[睡]': '108.gif',
    '[大哭]': '109.gif',

    '[尴尬]': '110.gif',
    '[发怒]': '111.gif',
    '[调皮]': '112.gif',
    '[呲牙]': '113.gif',
    '[惊讶]': '114.gif',
    '[难过]': '115.gif',
    '[酷]': '116.gif',
    '[冷汗]': '117.gif',
    '[抓狂]': '118.gif',
    '[吐]': '119.gif',

    '[偷笑]': '120.gif',
    '[愉快]': '121.gif',
    '[白眼]': '122.gif',
    '[傲慢]': '123.gif',
    '[饥饿]': '124.gif',
    '[困]': '125.gif',
    '[惊恐]': '126.gif',
    '[流汗]': '127.gif',
    '[憨笑]': '128.gif',
    '[悠闲]': '129.gif',

    '[奋斗]': '130.gif',
    '[咒骂]': '131.gif',
    '[疑问]': '132.gif',
    '[嘘]': '133.gif',
    '[晕]': '134.gif',
    '[疯了]': '135.gif',
    '[衰]': '136.gif',
    '[骷髅]': '137.gif',
    '[敲打]': '138.gif',
    '[再见]': '139.gif',

    '[擦汗]': '140.gif',
    '[抠鼻]': '141.gif',
    '[鼓掌]': '142.gif',
    '[糗大了]': '143.gif',
    '[坏笑]': '144.gif',
    '[左哼哼]': '145.gif',
    '[右哼哼]': '146.gif',
    '[哈欠]': '147.gif',
    '[鄙视]': '148.gif',
    '[委屈]': '149.gif',

    '[快哭]': '150.gif',
    '[阴险]': '151.gif',
    '[亲亲]': '152.gif',
    '[吓]': '153.gif',
    '[可怜]': '154.gif',
    '[菜刀]': '155.gif',
    '[西瓜]': '156.gif',
    '[啤酒]': '157.gif',
    '[篮球]': '158.gif',
    '[乒乓]': '159.gif',

    '[咖啡]': '160.gif',
    '[饭]': '161.gif',
    '[猪头]': '162.gif',
    '[玫瑰]': '163.gif',
    '[凋谢]': '164.gif',
    '[嘴唇]': '165.gif',
    '[爱心]': '166.gif',
    '[心碎]': '167.gif',
    '[蛋糕]': '168.gif',
    '[闪电]': '169.gif',

    '[炸弹]': '170.gif',
    '[刀]': '171.gif',
    '[足球]': '172.gif',
    '[瓢虫]': '173.gif',
    '[便便]': '174.gif',
    '[月亮]': '175.gif',
    '[太阳]': '176.gif',
    '[礼物]': '177.gif',
    '[拥抱]': '178.gif',
    '[强]': '179.gif',

    '[弱]': '180.gif',
    '[握手]': '181.gif',
    '[胜利]': '182.gif',
    '[抱拳]': '183.gif',
    '[勾引]': '184.gif',
    '[拳头]': '185.gif',
    '[差劲]': '186.gif',
    '[爱你]': '187.gif',
    '[No]': '188.gif',
    '[OK]': '189.gif',

    '[爱情]': '190.gif',
    '[飞吻]': '191.gif',
    '[跳跳]': '192.gif',
    '[发抖]': '193.gif',
    '[怄火]': '194.gif',
    '[转圈]': '195.gif',
    '[磕头]': '196.gif',
    '[回头]': '197.gif',
    '[跳绳]': '198.gif',
    '[投降]': '199.gif',

    '[激动]': '201.gif',
    '[乱舞]': '202.gif',
    '[献吻]': '203.gif',
    '[左太极]': '204.gif',
    '[右太极]': '205.gif'
  },
  // emoji表情, code代表来自微信端的表情字符，目前已经在服务器端处理替换为title字段，故code字段暂无用途
  emojis: [
    { title: '[微笑]', file: '100.gif' },
    { title: '[撇嘴]', file: '101.gif' },
    { title: '[色]', file: '102.gif' },
    { title: '[发呆]', file: '103.gif' },
    { title: '[得意]', file: '104.gif' },
    { title: '[流泪]', file: '105.gif' },
    { title: '[害羞]', file: '106.gif' },
    { title: '[闭嘴]', file: '107.gif' },
    { title: '[睡]', file: '108.gif' },
    { title: '[大哭]', file: '109.gif' },

    { title: '[尴尬]', file: '110.gif' },
    { title: '[发怒]', file: '111.gif' },
    { title: '[调皮]', file: '112.gif' },
    { title: '[呲牙]', file: '113.gif' },
    { title: '[惊讶]', file: '114.gif' },
    { title: '[难过]', file: '115.gif' },
    { title: '[酷]', file: '116.gif' },
    { title: '[冷汗]', file: '117.gif' },
    { title: '[抓狂]', file: '118.gif' },
    { title: '[吐]', file: '119.gif' },

    { title: '[偷笑]', file: '120.gif' },
    { title: '[愉快]', file: '121.gif' },
    { title: '[白眼]', file: '122.gif' },
    { title: '[傲慢]', file: '123.gif' },
    { title: '[饥饿]', file: '124.gif' },
    { title: '[困]', file: '125.gif' },
    { title: '[惊恐]', file: '126.gif' },
    { title: '[流汗]', file: '127.gif' },
    { title: '[憨笑]', file: '128.gif' },
    { title: '[悠闲]', file: '129.gif' },

    { title: '[奋斗]', file: '130.gif' },
    { title: '[咒骂]', file: '131.gif' },
    { title: '[疑问]', file: '132.gif' },
    { title: '[嘘]', file: '133.gif' },
    { title: '[晕]', file: '134.gif' },
    { title: '[疯了]', file: '135.gif' },
    { title: '[衰]', file: '136.gif' },
    { title: '[骷髅]', file: '137.gif' },
    { title: '[敲打]', file: '138.gif' },
    { title: '[再见]', file: '139.gif' },

    { title: '[擦汗]', file: '140.gif' },
    { title: '[抠鼻]', file: '141.gif' },
    { title: '[鼓掌]', file: '142.gif' },
    { title: '[糗大了]', file: '143.gif' },
    { title: '[坏笑]', file: '144.gif' },
    { title: '[左哼哼]', file: '145.gif' },
    { title: '[右哼哼]', file: '146.gif' },
    { title: '[哈欠]', file: '147.gif' },
    { title: '[鄙视]', file: '148.gif' },
    { title: '[委屈]', file: '149.gif' },

    { title: '[快哭]', file: '150.gif' },
    { title: '[阴险]', file: '151.gif' },
    { title: '[亲亲]', file: '152.gif' },
    { title: '[吓]', file: '153.gif' }
  ]
}
